import { render, staticRenderFns } from "./CenterFlux.vue?vue&type=template&id=68e24998&"
import script from "./CenterFlux.vue?vue&type=script&lang=js&"
export * from "./CenterFlux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports